import { Backdrop } from '@pets-ui/Backdrop/Backdrop'
import { Button } from '@pets-ui/Button/Button'
import { Divider } from '@pets-ui/Divider/Divider'
import { ArrowDownLarge, ArrowUpLarge } from '@pets-ui/icons'
import { Menu } from '@pets-ui/Menu/Menu'
import { Portal } from '@pets-ui/Portal/Portal'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom-v5'
import { isIncludesPath } from '../utils/isIncludesPath'
import { WpMyAccountSidebar, type WpMyAccountSidebarProps } from './WpMyAccountSidebar'

const styles = stylex.create({
  button: {
    padding: 16,
    borderRadius: 0,
    backgroundColor: colors.white,
    zIndex: 2,
  },
  menu: {
    maxHeight: 'auto',
    width: '100%',
  },
})

export const WpMyAccountSidebarDropdown = (props: WpMyAccountSidebarProps) => {
  const { menuItem, onNavigation } = props
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const { pathname } = useLocation()

  const toggleOpen = () => {
    setOpen(v => !v)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleNavigation = (route: string) => {
    handleClose()
    onNavigation?.(route)
  }

  const title = useMemo(() => {
    let longestMatchPath = ''
    let longestMatchTitle = ''

    const checkMatch = (key: string, itemTitle: string) => {
      if (isIncludesPath(key, pathname) && key.length > longestMatchPath.length) {
        longestMatchPath = key
        longestMatchTitle = itemTitle
      }
    }

    menuItem.filter(item => item.show).forEach((item) => {
      if (item.children) {
        item.children.forEach((child) => {
          checkMatch(child.key, child.title)
          child.activeKeys?.forEach(activeKey => checkMatch(activeKey, child.title))
        })
      }
      else {
        checkMatch(item.key, item.title)
        item.activeKeys?.forEach(activeKey => checkMatch(activeKey, item.title))
      }
    })
    return longestMatchTitle
  }, [menuItem, pathname])

  return (
    <>
      <Button
        rootStyle={styles.button}
        rootRef={setAnchorEl}
        fullWidth
        variant="text"
        onClick={toggleOpen}
        endIcon={open ? <ArrowUpLarge color={colors.grey900} /> : <ArrowDownLarge color={colors.grey900} />}
      >
        <Text variant="h4" bold color={colors.grey900}>
          {title}
        </Text>
      </Button>
      <Divider />
      <Menu
        anchorEl={anchorEl}
        open={open}
        rootStyle={styles.menu}
        offset={[0, 0]}
        PaperProps={{ borderRadius: 0 }}
      >
        <WpMyAccountSidebar menuItem={menuItem} onNavigation={handleNavigation} />
      </Menu>
      <Portal>
        <Backdrop open={open} onClick={handleClose} zIndex={1} />
      </Portal>
    </>
  )
}
